import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Select, FormLabel } from '@stockx/ui';
import { ConditionSelectProps } from './ConditionSelectProps';

const ConditionSelect: React.FC<ConditionSelectProps> = ({
  setValue,
  name,
}) => {
  const { t } = useTranslation();

  const selectOptions = useMemo(
    () => [
      { value: '', text: t('Choose Condition') },
      { value: 950, text: '9.5/10' },
      { value: 900, text: '9/10' },
      { value: 850, text: '8.5/10' },
      { value: 800, text: '8/10' },
      { value: 700, text: '7/10' },
      { value: 600, text: '6/10' },
      { value: 500, text: '5/10' },
      { value: 400, text: '4/10' },
      { value: 300, text: '3/10' },
      { value: 200, text: '2/10' },
      { value: 100, text: '1/10' },
    ],
    [t],
  );

  return (
    <div className="form-group conditions">
      <FormLabel mb={2} fontWeight={'bold'} htmlFor={name}>
        {t('Rate Used Condition')}
      </FormLabel>
      <Select
        id={name}
        name={name}
        data-testid="condition-select-list"
        onChange={(e) => setValue(e.target.value)}
      >
        {selectOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.text}
          </option>
        ))}
      </Select>
    </div>
  );
};

export default ConditionSelect;
